export class CloseAllModalsEvent {
  constructor(){ }
}


// WEBPACK FOOTER //
// ./src/app/shared/events/close-all-modals-event.ts